export const courtListenerMonitorSchemaVersion = 1;
export const courtListenerMonitorProvider = "courtlistener";

const requiredString = (value, label, maxLength) => {
  const normalizedValue = String(value ?? "").trim();

  if (!normalizedValue || normalizedValue.length > maxLength) {
    throw new Error(`A valid ${label} is required.`);
  }

  return normalizedValue;
};

const positiveInteger = (value, label) => {
  const normalizedValue = Number(value);

  if (!Number.isSafeInteger(normalizedValue) || normalizedValue <= 0) {
    throw new Error(`A valid ${label} is required.`);
  }

  return normalizedValue;
};

export const normalizeCourtListenerMonitor = monitor => ({
  schemaVersion: courtListenerMonitorSchemaVersion,
  litigationId: requiredString(monitor?.litigationId, "Litigation", 128),
  mdlNumber: positiveInteger(monitor?.mdlNumber, "MDL number"),
  provider: courtListenerMonitorProvider,
  courtListenerDocketId: positiveInteger(
    monitor?.courtListenerDocketId,
    "CourtListener docket ID"
  ),
  courtListenerAlertId:
    monitor?.courtListenerAlertId == null || monitor.courtListenerAlertId === ""
      ? null
      : positiveInteger(monitor.courtListenerAlertId, "CourtListener alert ID"),
  courtId: requiredString(monitor?.courtId, "court ID", 40).toLowerCase(),
  docketNumber: requiredString(monitor?.docketNumber, "docket number", 120),
  caseName: requiredString(monitor?.caseName, "case name", 300),
  enabled: monitor?.enabled !== false
});
